// Extra scope value passed in by native app to identify it
const NATIVE_SCOPE = 'native';

// Detect if page is being loaded inside the native app by checking for 'native' scope
export const isNative = (): boolean => {
  const scope = getParam('scope');
  if (scope && scope.indexOf(NATIVE_SCOPE) !== -1) {
    return true;
  } else {
    const auth0Config = (window as any).auth0Config;
    if (auth0Config && auth0Config.internalOptions && auth0Config.internalOptions.scope) {
      return auth0Config.internalOptions.scope.indexOf(NATIVE_SCOPE) !== -1;
    }
  }
  return false;
};

const getParam = (name: string, url?: string): string => {
  if (!url) {
    url = window.location.href;
  }
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  const regexS = '[\\?&]' + name + '=([^&#]*)';
  const regex = new RegExp(regexS);
  const results = regex.exec(url);
  return results == null ? null : results[1];
};
